import React from "react";
import "./filterBox.css";

const FilterBox = ({children,title, order, spacePadding})=> {
    let elements = children;
    return (
        <div className={`filterBox ${spacePadding ? 'space-padding' : ''}`} style={{padding: order ? '10px' : ""}}>
            <h3>{title}</h3>
            <div className="inputsFilter">
                {React.Children.map(elements,(e) => {
                    if(e.props.type == "input"){
                            {return e} 
                    }
                })}
            </div>
            <div className="buttonsFilter">
                {React.Children.map(elements,(e) => {
                    if(e.props.type == "button"){
                            {return e} 
                    }
                })}
            </div>
        </div>
    );
};

export default FilterBox;